import React, { useState } from "react";
import { CreditCard, Upload, Clock, RefreshCw, Receipt, Headphones } from "lucide-react";
import { api } from "../lib/api";
import { PageHero, Field, SuccessCard } from "../components/FormKit";
import { toast } from "sonner";

const SECTIONS = [
  { icon: CreditCard, title: "Request a Card", text: "Submit your details to request a Sebara Virtual Card." },
  { icon: Upload, title: "KYC Upload", text: "Securely provide identity verification documents." },
  { icon: Clock, title: "Card Status", text: "Track your card request review status." },
  { icon: RefreshCw, title: "Recharge Request", text: "Request a balance recharge on your card." },
  { icon: Receipt, title: "Transaction History", text: "View your card transaction activity." },
  { icon: Headphones, title: "Support", text: "Reach the Sebara support team for help." },
];

export const SebaraCard = () => {
  const [f, setF] = useState({ full_name: "", email: "", phone: "", country: "", reason: "", request_type: "new_card" });
  const [done, setDone] = useState(false);
  const set = (k, v) => setF({ ...f, [k]: v });
  const submit = async (e) => { e.preventDefault(); try { await api.post("/leads/sebara-card", f); setDone(true); toast.success("Request submitted"); } catch { toast.error("Please try again."); } };

  return (
    <div data-testid="sebara-page">
      <PageHero eyebrow="TAVEN SYSTEM LLC" title="Sebara Virtual Card" subtitle="Request a card and manage your ecosystem finances. A modern request and information system inside TAVEN." />

      <section className="py-14 px-4 md:px-8 lg:px-12 mx-auto max-w-7xl grid md:grid-cols-3 gap-4">
        {SECTIONS.map((s) => (
          <div key={s.title} className="p-6 bg-white border border-black/5 hover-lift"><s.icon className="w-7 h-7 text-taven-gold" /><h3 className="font-black font-display text-lg mt-3">{s.title}</h3><p className="text-sm text-muted-foreground mt-1">{s.text}</p></div>
        ))}
      </section>

      <section className="py-6 pb-16 px-4 md:px-8 lg:px-12 mx-auto max-w-2xl">
        <h2 className="text-2xl font-black font-display text-center mb-6">Request a Card</h2>
        {done ? <SuccessCard title="Your card request has been received." text="Your request will be reviewed. Cards are not automatically approved." /> : (
          <form onSubmit={submit} className="grid gap-4" data-testid="sebara-form">
            <Field label="Full Name" name="full_name" value={f.full_name} onChange={set} required />
            <Field label="Email" name="email" type="email" value={f.email} onChange={set} required />
            <Field label="Phone" name="phone" value={f.phone} onChange={set} />
            <Field label="Country" name="country" value={f.country} onChange={set} />
            <Field label="Reason for Card Request" name="reason" value={f.reason} onChange={set} textarea />
            <div className="grid grid-cols-3 gap-3">
              {["ID Upload", "Selfie Upload", "Proof of Address"].map((k) => (
                <div key={k} className="border border-dashed border-black/20 p-4 text-center bg-taven-gray/40"><Upload className="w-5 h-5 mx-auto text-black/40" /><p className="text-[11px] font-semibold mt-2">{k}</p><p className="text-[10px] text-muted-foreground">Coming soon</p></div>
              ))}
            </div>
            <button className="bg-taven-black text-white font-bold uppercase tracking-wider py-4 hover:bg-taven-orange transition-colors" data-testid="sebara-submit">Submit Card Request</button>
          </form>
        )}
        <p className="text-xs text-muted-foreground mt-6 border-t border-black/10 pt-4">This is a request and information system. Sebara Virtual Card issuing and payments are not yet active. Cards are not automatically approved.</p>
      </section>
    </div>
  );
};

export default SebaraCard;
